import {SERVICES} from "../../constants/services";

export function fetchServicesPageData(params) {
  return {
    type: SERVICES.FETCH_SERVICES_PAGE.MAIN,
    params
  }
}
